import { DateValue } from '@internationalized/date';
import { toISODateString } from '@rematter/common/dateTime';
import { ReceivedLineItemInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadMarkAsReceivedAtom = createMutationAtomFactory(
  'trade.loadMarkAsReceived',
  (params: {
    loadId: string;
    receivedDate: DateValue;
    receivedLineItems: ReceivedLineItemInput[];
  }) => ({
    tradeLoadReceive: {
      __args: {
        id: params.loadId,
        receivedDate: toISODateString(params.receivedDate),
        receivedLineItems: params.receivedLineItems,
        reviewed: true,
      },
      id: true,
    },
  }),
  {
    skipQueue: true,
  },
);
